var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',[_vm._t("default")],2):_c('v-skeleton-loader',{style:(_vm.styles),attrs:{"type":_vm.type,"width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }